import { motion } from "framer-motion";
import { ArrowUp, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT } from "../content";
import { scrollToId } from "./SmoothScroll";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 pt-20 pb-28 sm:pb-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo size="h-12" />
          <p className="font-display mt-8 text-3xl italic leading-snug text-zinc-200 max-w-sm">
            Right talent. Stronger leadership. A more resilient tomorrow.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button onClick={() => scrollToId(n.id)} className="text-sm text-zinc-300 hover:text-emerald-300 transition-colors" data-testid={`footer-link-${n.id}`}>
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow">Contact</p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-300">
            <li>{CONTACT.email}</li>
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-emerald-300 transition-colors" data-testid="footer-whatsapp-link">
                <MessageCircle className="h-4 w-4 text-emerald-400" />
                WhatsApp: {CONTACT.phone}
              </a>
            </li>
            <li>{CONTACT.address}</li>
          </ul>
        </div>
      </div>
      <motion.img
        src="/images/pluk-wordmark.png"
        alt=""
        aria-hidden="true"
        draggable="false"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto mt-20 block w-full max-w-[880px] select-none"
        data-testid="footer-big-logo"
      />
      <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-6 text-xs text-zinc-400 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} PLUK HR · A product vertical of Anweta Ventures Private Limited.</p>
        <div className="flex flex-wrap items-center gap-5">
          <span className="inline-flex items-center gap-3" data-testid="footer-admin-links">
            Admin:
            <a href="/careers-admin" className="hover:text-emerald-300 underline-offset-4 hover:underline" data-testid="footer-careers-admin-link">Careers</a>
            <a href="/admin" className="hover:text-emerald-300 underline-offset-4 hover:underline" data-testid="footer-mandates-admin-link">Mandates</a>
          </span>
          <button onClick={() => scrollToId("top")} className="inline-flex items-center gap-2 hover:text-emerald-300" data-testid="footer-back-to-top">
            Back to top <ArrowUp className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  </footer>
);
